// A Glance `format` is a preset name ("inr", "pct"…) or a function. Report charts send an
// object instead — the org's number scale from Reports::Chart::Glance, { divisor, suffix,
// precision, locale } — so a Glance chart reads like the rest of the report ("12.3 L").
// Used by glance_controller.js and GlanceChart; anything that isn't an object passes through.
export function glanceFormat(format) {
  if (!format || typeof format !== "object") return format;

  const { divisor = 1, suffix, precision = 0, locale = "en-IN" } = format;
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: precision });
  return (value) => {
    const scaled = Number(value) / divisor;
    return `${scaled < 0 ? "−" : ""}${number.format(Math.abs(scaled))}${suffix ? ` ${suffix}` : ""}`;
  };
}
